import * as uuid from 'uuid';

import {ProcessInteractiveFlowchart} from 'processes/graph-builder-processes/flowchart-viz/ProcessFlowchartVizConstants';
import {
  makeOutputNode,
  makeRootNode,
} from 'processes/graph-builder-processes/flowchart-viz/util/makeProcessFlowchartInteractiveNode';

export default function getEmptyFlowchart(rootTaskSchema: {
  id: string;
  name: string;
  outputSchema: {id: string} | null;
}): ProcessInteractiveFlowchart {
  return {
    clientId: uuid.v4(),
    nodes: [
      makeRootNode(rootTaskSchema.name, rootTaskSchema),
      ...(rootTaskSchema.outputSchema != null ? [makeOutputNode(rootTaskSchema)] : []),
    ],
    edges: [],
  };
}
